import styled from 'styled-components';
import { IconButton } from 'ui/button';
import { colors, body2, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const ParentRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${spacing.half} ${spacing.plusHalf};
  ${body2}
`;

export const Row = styled.div<{ last: boolean }>`
  background-color: ${colors.white};
  display: flex;
  justify-content: space-between;
  padding: ${spacing.half} ${spacing.plusHalf} ${spacing.half} ${pxToRem(40)};
  ${body2}

  &:last-child {
    ${(props) => (props.last ? '' : `border-bottom: 1px solid ${colors.grey10};`)}
  }
`;

export const CollapseBtn = styled(IconButton)`
  margin-right: ${spacing.half};
`;
